module.exports = __webpack_public_path__ + "static/media/REcorded_Sessions2.07649968.png";